// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"51371d79","726":"51371d79","813":"3b53517f"}[chunkId] + ".chunk.css";
};